import type { TokenImageSlug } from '../../components/TokenRender'

export const fund_symbols = ['TECH'] as const
export type FundSymbol = (typeof fund_symbols)[number]

export const simulated_fund_symbols = [
  'BLK',
  'FIN',
  'CON',
  'IND',
  'SFT',
  'AID',
  'TOKX',
] as const
export type SimulatedFundSymbol = (typeof simulated_fund_symbols)[number]

export const all_fund_symbols = [
  ...simulated_fund_symbols,
  ...fund_symbols,
] as const
export type AllFundSymbol = FundSymbol | SimulatedFundSymbol

export function isActiveFund(symbol: AllFundSymbol) {
  return fund_symbols.includes(symbol as FundSymbol)
}

export const vault_symbols = ['TVLT'] as const
export type VaultSymbol = (typeof vault_symbols)[number]

export type ProductSymbol = FundSymbol | VaultSymbol

export const other_symbols = ['USDC', 'FISN'] as const
export type OtherSymbol = (typeof other_symbols)[number]

export const addressable_symbols = [
  ...fund_symbols,
  ...vault_symbols,
  ...other_symbols,
] as const
export type AddressableSymbol = (typeof addressable_symbols)[number]

export type TokenSymbol = AddressableSymbol | SimulatedFundSymbol

export type TokenName = {
  symbol: TokenSymbol
  image_slug: TokenImageSlug
  name: string
  long_name: string
}

export function getTokenNames(symbol: TokenSymbol): TokenName {
  return names[symbol]
}

export function isAddressableToken(symbol: TokenSymbol) {
  return addressable_symbols.includes(symbol as AddressableSymbol)
}

export function toAddressableToken(symbol: TokenSymbol) {
  if (!isAddressableToken(symbol)) {
    console.error(`Invalid token symbol: ${symbol}`)
  }
  return symbol as AddressableSymbol
}

const names: Record<TokenSymbol, TokenName> = {
  USDC: {
    long_name: 'USDC',
    name: 'USDC',
    symbol: 'USDC',
    image_slug: 'usdc',
  },
  FISN: {
    long_name: 'Fission Foundation Governance Token',
    name: 'FISN',
    symbol: 'FISN',
    image_slug: 'fisn',
  },
  BLK: {
    long_name: 'Fission Blockchain Holdings',
    name: 'Blockchain',
    symbol: 'BLK',
    image_slug: 'blockchain',
  },
  FIN: {
    long_name: 'Fission Fintech Holdings',
    name: 'Fintech',
    symbol: 'FIN',
    image_slug: 'fintech',
  },
  CON: {
    long_name: 'Fission Consumer Holdings',
    name: 'Consumer',
    symbol: 'CON',
    image_slug: 'consumer',
  },
  IND: {
    long_name: 'Fission Industrial Holdings',
    name: 'Industrial',
    symbol: 'IND',
    image_slug: 'industrial',
  },
  SFT: {
    long_name: 'Fission Software Holdings',
    name: 'Software',
    symbol: 'SFT',
    image_slug: 'software',
  },
  AID: {
    long_name: 'Fission AI \u0026 Data Holdings',
    name: 'AI \u0026 Data',
    symbol: 'AID',
    image_slug: 'ai-data',
  },
  TOKX: {
    long_name: 'Fission Musk Companies Holdings',
    name: 'Token X',
    symbol: 'TOKX',
    image_slug: 'token-x',
  },
  TECH: {
    long_name: 'Fission Technology Holdings',
    name: 'Technology',
    symbol: 'TECH',
    image_slug: 'technology',
  },
  TVLT: {
    long_name: 'Fission TECH Vault',
    name: 'TECH Vault',
    symbol: 'TVLT',
    image_slug: 'technology',
  },
}
